import env from '../../../../env/env';

export const TRIVIA_QUESTION = `${env.REACT_APP_STATIC_BASE_URL}marketplace/trivia/questionAsset.svg`;
